import { URL } from "whatwg-url";
import { stringify } from "query-string";

/**
 * Helps build URL & normalize it using standard URL() constructor
 * (https://developer.mozilla.org/en-US/docs/Web/API/URL/URL). Check out specs
 * for some examples.
 *
 * Note: Requires whatwg-url polyfill to work with IE(? - 11).
 */

export default function(baseUrl, options) {
  let url = baseUrl;
  let path;
  let hash;
  let query;

  if (typeof options === "string") {
    path = options;
  } else if (options) {
    ({ path, hash, query } = options);
  }

  if (path) {
    if (!url.endsWith("/")) {
      url += "/";
    }
    if (path.startsWith("/")) {
      url += path.substr(1);
    } else {
      url += path;
    }
  }

  if (hash) {
    url += hash.startsWith("#") ? hash : `#${hash}`;
  }

  if (query) {
    const stringQuery = typeof query === "string" ? query : stringify(query);

    url += stringQuery.startsWith("?") ? stringQuery : `?${stringQuery}`;
  }
  return new URL(url).toString();
}
